import { getPortalComponents } from "../../components/Portal";

const {
  ContentRendered: LayoutBackground,
  ContentPlaceholder: LayoutBackgroundPlaceholder,
} = getPortalComponents();


export {
  LayoutBackground,
  LayoutBackgroundPlaceholder,
};
